import { FC } from "react";
import { TableCell, TableHeadCell } from "@rothoblaas/design-system";
import AdminCrudTable from "../../../../components/ui/AdminCrudTable";
import useI18n from "../../../../hooks/useTranslations";
import { ConnectorMapping } from "../../../../http/deckDesigner/types/connectorMappings";
import useDeckConnectorMappingsApi from "../../../../http/deckDesigner/useConnectorMappings";
import ConnectorMappingForm from "./ConnectorMappingForm";
import { getItemOptionLabel } from "../../../../hooks/useItemOptions";

const AdminConnectorMappings: FC = () => {
  const i18n = useI18n();
  const connectorMappingsApi = useDeckConnectorMappingsApi();

  return (
    <AdminCrudTable<ConnectorMapping>
      filterPrefix="connector_mappings"
      useList={connectorMappingsApi.useDeckConnectorMappings}
      head={
        <>
          <TableHeadCell align="left">
            {i18n.translation.deckDesignerModule.substructureMaterials.singular}
          </TableHeadCell>
          <TableHeadCell align="left">{i18n.translation.deckDesignerModule.fasteningTypes.singular}</TableHeadCell>
          <TableHeadCell align="left">{i18n.translation.deckDesignerModule.groovingTypes.singular}</TableHeadCell>
          <TableHeadCell align="left">{i18n.translation.common.gap}</TableHeadCell>
          <TableHeadCell align="left">{i18n.translation.deckDesignerModule.connectorFamilies.singular}</TableHeadCell>
          <TableHeadCell align="left">{i18n.translation.deckDesignerModule.secondaryItems.singular}</TableHeadCell>
        </>
      }
      renderRow={(item) => (
        <>
          <TableCell>{item.substructureMaterials.map((m) => m.name).join(", ")}</TableCell>
          <TableCell>{item.fasteningType.name}</TableCell>
          <TableCell>{item.groovingType.name}</TableCell>
          <TableCell>
            {item.minimumGap} - {item.maximumGap} {i18n.translation.common.unitMm}
          </TableCell>
          <TableCell>{item.connectorFamily.name}</TableCell>
          <TableCell>{item.secondaryItem ? getItemOptionLabel(item.secondaryItem.item) : ""}</TableCell>
        </>
      )}
      onDelete={(item) => connectorMappingsApi.deleteDeckConnectorMapping(item.id)}
      deleteTitle={i18n.translation.deckDesignerModule.connectorMappings.singular}
      canAdd
      renderForm={(item, onClose) => <ConnectorMappingForm connectorMapping={item} onClose={onClose} />}
    />
  );
};

export default AdminConnectorMappings;
